
export default function urlBackEnd(url) {
    //const urlBack = 'http://127.0.0.1:8000';
    const urlBack = 'https://api.sun-be.market';
    return urlBack + url
}